import { render, staticRenderFns } from "./Merchants.vue?vue&type=template&id=11db98e4&scoped=true&"
import script from "./Merchants.vue?vue&type=script&lang=js&"
export * from "./Merchants.vue?vue&type=script&lang=js&"
import style0 from "./Merchants.vue?vue&type=style&index=0&id=11db98e4&prod&lang=scss&scoped=true&"
import style1 from "./Merchants.vue?vue&type=style&index=1&id=11db98e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11db98e4",
  null
  
)

export default component.exports